<template>
  <div>
    <vue-excel-xlsx
    :data="data"
    :columns="columns"
    :filename="'franquias'"
    :sheetname="'sheetname'"
    v-if="controlerBtnSubmit == true"
    class="btn btn-primary"
    >
    Franquias e Corretivas Associadas
    </vue-excel-xlsx>
    <button type="button" class="btn btn-primary" disabled v-else><i class='fa fa-refresh fa-spin'></i> Carregando Franquias e Corretivas Associadas...</button>
  </div>
</template>

<script>
import VueExcelXlsx from 'vue-excel-xlsx'
import Vue from 'vue'
Vue.use(VueExcelXlsx)

export default {
  // lista de franquias passada pelo componente Index
  // variavel que irá armazenar os dados que serão exportados para planilha Excel
  data () {
    return {
      env: process.env,
      franquias: [],
      controlerBtnSubmit: false,
      // colunas para composição da planilha Excel
      columns: [
        {
          label: 'franquia_id',
          field: 'franquia_id'
        },
        {
          label: 'dt_criacao_franquia',
          field: 'dt_criacao_franquia'
        },
        {
          label: 'franquia_status',
          field: 'franquia_status'
        },
        {
          label: 'chamado_id',
          field: 'chamado_id'
        },
        {
          label: 'chamado_status',
          field: 'chamado_status'
        },
        {
          label: 'dt_criacao_chamado',
          field: 'dt_criacao_chamado'
        },
        {
          label: 'uf',
          field: 'uf'
        },
        {
          label: 'sigla',
          field: 'sigla'
        }
      ]
    }
  },
  watch: {
    // registros: function () {
    //   this.franquias = this.registros
    //   // console.warn(this.franquias)
    // },
    // função para atribuir os dados recebidos na variável franquias e formatá-los
    // franquias: function () {
    //   // console.log(this.franquias);
    //   this.formatarDados()
    // }
  },
  mounted: function () {
    this.planilhaFranquia()
  },
  methods: {
    planilhaFranquia () {
      let vm = this

      this.$axios.get(`${this.env.FINANCEIRO.SLA}/getFranquiasChamados`, {
        headers: {
          'Authorization': `Bearer ${this.$store.state.login.loginUsuario.token}`
        }
      })
      .then(function (response) {
        // sla = response.data
        vm.franquias = response.data
        vm.data = response.data
        vm.formatarDados()
        vm.controlerBtnSubmit = true
      })
    },
    priceFormat (value) {
      return 'R$ ' + value
    },
    // função para formatar os dados da lista de franquias e adcionálos ao array que irá preencher a planilha Excel
    formatarDados () {
      this.data = []
      this.data = this.franquias.map(franquia => {
        return {
          ...franquia
        }
      })
    },
    moeda: function (val) {
      if (val !== '' && val !== null) {
        let val2 = val.toLocaleString('pt-br', {style: 'currency', currency: 'BRL'})
        val2 = val2.replace('.', ',')
        return val2
      } else {
        return val
      }
    },
    formataDataBrasil: function (dataForm) {
      if (dataForm !== '' && dataForm !== undefined && dataForm !== null) {
        let dataHoraAntigaSeparada = dataForm.split(' ')
        let dataSeparada = dataHoraAntigaSeparada[0].split('-')
        return `${dataSeparada[2]}/${dataSeparada[1]}/${dataSeparada[0]}`
      }
      return dataForm
    },
    formataMesPorExtenso: function (mes) {
      let mesesAno = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro']
      return `${mesesAno[mes - 1]}`
    }
  }
}
</script>

<style scoped>
  /* button {
    float: right;
    border: 0;
    padding: 6px;
    margin-top: 5px;
    margin-bottom: 20px;
    border-radius: 5px;
    color: #fff;
    background-color: #3c8dbc;
    border-color: #6c757d;
  } */
  button:hover {
    background-color: #6c757d;
  }
  /* button {
    background-color:#3c7fe4;
    color: white;
    margin: 1%;
    padding-left:0px;
    padding-right:0px;
    padding-bottom:5px;
    padding-top:5px;
    border-style: none;
    border-radius: 5px;
  } */
</style>



// WEBPACK FOOTER //
// ExportFranquiasChamados.vue?39622768